import { Typography, Stack, Icon, Box } from '@ace-clublabs/shared-component-library';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import { CurrentPayPlan, MembershipLevel } from '@ace-clublabs/common-membership-api-types';
import {
  convertBillPlanToTerm,
  getMembershipTitle,
  getCostByMembershipLevel,
  getBaseCostByMembershipLevel,
  formatFullName,
} from '../../utils/helpers';
import { AddedInfoCard } from './AddedInfoCard';
import { ProductType } from '../../application/models/NewJoinSessionData';

export interface BenefitLevelCardProps {
  onEditClick?: () => void;
}

export const BenefitLevelCard = ({ onEditClick }: BenefitLevelCardProps) => {
  const { membershipInfo, sessionData } = useContext(MembershipAppStateContext);
  const { firstName, lastName, billPlan } = sessionData.formData;
  const membershipLevel = sessionData.formData.membershipLevel;
  const ml =
    membershipLevel == undefined ||
    membershipLevel == MembershipLevel.CLASSIC_RV ||
    membershipLevel == MembershipLevel.CLASSIC
      ? MembershipLevel.CLASSIC
      : membershipLevel == MembershipLevel.PLUS_RV || membershipLevel == MembershipLevel.PLUS
        ? MembershipLevel.PLUS
        : membershipLevel == MembershipLevel.PREMIER_RV || membershipLevel == MembershipLevel.PREMIER
          ? MembershipLevel.PREMIER
          : membershipLevel;
  const selectedTerm = convertBillPlanToTerm(sessionData.formData?.billPlan!);
  const primaryMemberName = formatFullName(firstName, lastName);
  const priceSuffix = billPlan == CurrentPayPlan.RECURRINGMONTHLY ? 'month' : 'year';
  const membershipBaseCost = getBaseCostByMembershipLevel(ml, membershipInfo!, selectedTerm);
  const priceAfterDiscount = getCostByMembershipLevel(membershipInfo!, membershipLevel!, selectedTerm, sessionData);
  const hasRV = sessionData.formData?.products?.includes(ProductType.RV);
  const membershipTitle = <>{getMembershipTitle(sessionData.formData.membershipLevel!, hasRV) || 'Classic'} member</>;
  return (
    <Box className="benefit-level-container">
      <Stack direction="column" className="benefit-level-info" width="100%">
        <Stack direction="row" alignItems="center" sx={{ gap: '0.5rem' }}>
          <Icon
            iconName="card-membership-duotone"
            sx={{ color: '#0C7A93', fontSize: '1.5rem' }}
            className="membership-card-icon"
          />
          <Typography className="benefit-level-title" variant="h6Medium">
            Benefit level
          </Typography>
        </Stack>
        <AddedInfoCard
          title={membershipTitle}
          subtitle={primaryMemberName}
          content="Primary"
          editButtonOnClick={onEditClick}
          originalPrice={membershipBaseCost}
          priceAfterDiscount={priceAfterDiscount}
          priceSuffix={priceSuffix}
          className="primary"
          {...(membershipLevel !== MembershipLevel.CLASSIC && {
            subcontent: 'Benefits available 7 days after you join.',
          })}
        />
      </Stack>
    </Box>
  );
};
